module.exports = __webpack_public_path__ + "img/theme7.d48db20b.png";